/* tslint:disable */
/* eslint-disable */
/**
 * Billaan API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetApplicationStatusAndQuoteResponse,
  InitializeApplicationRequest,
  InitializeApplicationResponse,
  QuoteDecisionRequest,
  SaveApplicationProgressRequest,
  SubmitApplicationRequest,
} from '../models/index';
import {
    GetApplicationStatusAndQuoteResponseFromJSON,
    GetApplicationStatusAndQuoteResponseToJSON,
    InitializeApplicationRequestFromJSON,
    InitializeApplicationRequestToJSON,
    InitializeApplicationResponseFromJSON,
    InitializeApplicationResponseToJSON,
    QuoteDecisionRequestFromJSON,
    QuoteDecisionRequestToJSON,
    SaveApplicationProgressRequestFromJSON,
    SaveApplicationProgressRequestToJSON,
    SubmitApplicationRequestFromJSON,
    SubmitApplicationRequestToJSON,
} from '../models/index';

export interface GetApplicationStatusAndQuoteRequest {
    applicationId?: string;
}

export interface InitializeApplicationNEWRequest {
    body?: InitializeApplicationRequest;
}

export interface QuoteDecisionOperationRequest {
    body?: QuoteDecisionRequest;
}

export interface SaveApplicationProgressOperationRequest {
    body?: SaveApplicationProgressRequest;
}

export interface SubmitApplicationOperationRequest {
    body?: SubmitApplicationRequest;
}

/**
 * 
 */
export class ConsumerLoanApplicationApi extends runtime.BaseAPI {

    /**
     */
    async getApplicationStatusAndQuoteRaw(requestParameters: GetApplicationStatusAndQuoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetApplicationStatusAndQuoteResponse>> {
        const queryParameters: any = {};

        if (requestParameters['applicationId'] != null) {
            queryParameters['ApplicationId'] = requestParameters['applicationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/consumer-loan-application/get-application-status-and-quote`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetApplicationStatusAndQuoteResponseFromJSON(jsonValue));
    }

    /**
     */
    async getApplicationStatusAndQuote(requestParameters: GetApplicationStatusAndQuoteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetApplicationStatusAndQuoteResponse> {
        const response = await this.getApplicationStatusAndQuoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async initializeApplicationNEWRaw(requestParameters: InitializeApplicationNEWRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitializeApplicationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v2/consumer-loan-application/initialize-application`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InitializeApplicationRequestToJSON(requestParameters['body']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitializeApplicationResponseFromJSON(jsonValue));
    }

    /**
     */
    async initializeApplicationNEW(requestParameters: InitializeApplicationNEWRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitializeApplicationResponse> {
        const response = await this.initializeApplicationNEWRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async quoteDecisionRaw(requestParameters: QuoteDecisionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v2/consumer-loan-application/quote-decision`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QuoteDecisionRequestToJSON(requestParameters['body']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async quoteDecision(requestParameters: QuoteDecisionOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.quoteDecisionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async saveApplicationProgressRaw(requestParameters: SaveApplicationProgressOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v2/consumer-loan-application/save-application-progress`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveApplicationProgressRequestToJSON(requestParameters['body']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async saveApplicationProgress(requestParameters: SaveApplicationProgressOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveApplicationProgressRaw(requestParameters, initOverrides);
    }

    /**
     */
    async submitApplicationRaw(requestParameters: SubmitApplicationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v2/consumer-loan-application/submit-application`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitApplicationRequestToJSON(requestParameters['body']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async submitApplication(requestParameters: SubmitApplicationOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.submitApplicationRaw(requestParameters, initOverrides);
    }

}
